"use client";

import { c as _c } from "react/compiler-runtime";
import { MessageCircleQuestionMark, X } from "lucide-react";
import { usePathname } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { AiChatWindow } from "@/components/ui/AiChatWindow";
const BUBBLE_DELAY_MS = 10_000;
const BUBBLE_DISMISSED_KEY = "ai-chat-bubble-dismissed";

/** Pages où l'assistant IA est proposé : accueil, contact et portail connecté. */
function isAiChatVisible(pathname: string): boolean {
  return pathname === "/" || pathname === "/contact" || pathname.startsWith("/dashboard");
}
export function AiButton() {
  const $ = _c(23);
  const [showBubble, setShowBubble] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const buttonRef = useRef(null);
  const pathname = usePathname();
  const visible = isAiChatVisible(pathname);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (sessionStorage.getItem(BUBBLE_DISMISSED_KEY) === "1") {
        return;
      }
      const timer = setTimeout(() => setShowBubble(true), BUBBLE_DELAY_MS);
      return () => clearTimeout(timer);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setChatOpen(false);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== pathname) {
    t3 = [pathname];
    $[3] = pathname;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setShowBubble(false);
      sessionStorage.setItem(BUBBLE_DISMISSED_KEY, "1");
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const dismissBubble = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setChatOpen(_temp);
      dismissBubble();
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const toggleChat = t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setChatOpen(false);
      buttonRef.current?.focus();
    };
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const closeChat = t6;
  if (!visible) {
    return null;
  }
  let t7;
  if ($[8] !== chatOpen) {
    t7 = <AiChatWindow open={chatOpen} onClose={closeChat} />;
    $[8] = chatOpen;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = !showBubble || chatOpen;
  const t9 = `fixed bottom-6 right-20 z-30 max-w-55 origin-bottom-right transition-all duration-300 ease-out ${showBubble && !chatOpen ? "scale-100 opacity-100 translate-x-0" : "pointer-events-none invisible scale-0 opacity-0 translate-x-2"}`;
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <button type="button" onClick={dismissBubble} aria-label="Fermer la bulle" className="absolute top-2 right-2 text-white/70 hover:text-white transition-colors"><X className="h-4 w-4" /></button>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="relative rounded-2xl rounded-br-sm bg-blue-600 shadow-xl p-4 pr-8 text-sm text-white">{t10}Besoin d'aide ? Posez votre question à l'assistant IA.<div className="absolute -right-1.5 bottom-4 h-3 w-3 rotate-45 bg-blue-600" /></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== t8 || $[13] !== t9) {
    t12 = <div role="status" aria-hidden={t8} className={t9}>{t11}</div>;
    $[12] = t8;
    $[13] = t9;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  const t13 = `fixed bottom-6 right-6 z-30 inline-flex items-center justify-center text-blue-600 transition hover:text-blue-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 rounded-full ${chatOpen ? "max-md:hidden" : ""}`;
  let t14;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <MessageCircleQuestionMark className="h-12 w-12 drop-shadow-lg" strokeWidth={1.75} />;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== chatOpen || $[17] !== t13) {
    t15 = <button ref={buttonRef} type="button" onClick={toggleChat} aria-label="Assistant IA" aria-expanded={chatOpen} aria-haspopup="dialog" className={t13}>{t14}</button>;
    $[16] = chatOpen;
    $[17] = t13;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== t12 || $[20] !== t15 || $[21] !== t7) {
    t16 = <>{t7}{t12}{t15}</>;
    $[19] = t12;
    $[20] = t15;
    $[21] = t7;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  return t16;
}
function _temp(prev) {
  return !prev;
}